import API from "@/api";

const state = {
  contacts: [],
  pending: []
};

const getters = {
  acceptedContacts: state => {
    return state.contacts.filter(c => c.accepted === true);
  },

  getNickname: state => user => {
    const contact = state.contacts.find(c => c.id === user.id);
    return contact ? contact.nickname || contact.name : user.name;
  }
};

const mutations = {
  SET_CONTACTS(state, payload) {
    state.contacts = payload;
  },

  SET_PENDING(state, payload) {
    state.pending = payload;
  }
};

const actions = {
  async getContacts({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getContacts();
    commit("SET_CONTACTS", results);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async getPendingContacts({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getPendingContacts();
    commit("SET_PENDING", results);

    commit("REQUEST_DECREMENT", null, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
